import i18n from '@/lang/i18n'
import { Nullable } from '@/shared/types/app.types'

export enum TextTemplatesModalBasicFormVariablesAreaTypeSelection {
    SIMPLE_SELECTION = 'SIMPLE_SELECTION',
    FREE_TEXT='FREE_TEXT'
}
export interface TextTemplatesModalBasicFormVariablesAreaTypeOptions {
    value: Nullable<string>
    text?: string
}

export interface TextTemplatesModalBasicFormVariablesAreaSelectedVariable {
    id: string
    values: TextTemplatesModalBasicFormVariablesAreaTypeOptions[]
    typeSelected: TextTemplatesModalBasicFormVariablesAreaTypeOptions
}

export interface VariableToEmit {
    value: {}
    oldKey: string
    newKey: string
}

export interface TextTemplatesModalBasicFormVariablesAreaState {
    viewMode: boolean
    editingVariable: boolean
    selectedVariable: TextTemplatesModalBasicFormVariablesAreaSelectedVariable
    typeOptions: TextTemplatesModalBasicFormVariablesAreaTypeOptions[]
    selectedOption: TextTemplatesModalBasicFormVariablesAreaTypeOptions
    editingVariableText: string
}
export const initialTextTemplatesModalBasicFormVariablesAreaState =
    (): TextTemplatesModalBasicFormVariablesAreaState => ({
        viewMode: true,
        editingVariable: false,
        editingVariableText: '',
        selectedVariable: {
            id: '',
            values: [],
            typeSelected: {
                value: TextTemplatesModalBasicFormVariablesAreaTypeSelection.FREE_TEXT,
                text: i18n.tc('configuration.modal.textTemplate.freeText')
            }
        },
        typeOptions: [
            { value: TextTemplatesModalBasicFormVariablesAreaTypeSelection.FREE_TEXT, text: i18n.tc('configuration.modal.textTemplate.freeText') },
            { value: TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION, text: i18n.tc('configuration.modal.textTemplate.simpleSelection') }
        ],
        selectedOption: {
            value: null
        }
    })
